import { Component, Input } from '@angular/core';

@Component({
    selector: 'activity-row-signup',
    templateUrl: 'activity-row-signup.component.html',
    styleUrls: ['activity-row-signup.component.scss']
})
export class ActivityRowSignupComponent {
    showDetails = true;
    @Input() activity;
}
